import styles from "~/sass/organisms/Article/ArticleAuthor.module.scss";
import Head from "~/components/Meta/Head";
import Breadcrumb from "../../../components/Breadcrumb";
import ArticleCard from "../../../components/organisms/Article/ArticleCard";
import Image from "next/legacy/image";
import Script from "next/script";
import {
  ARTICLES as articles,
  BLOG_POSTS as blogPosts,
} from "../../../utils/Constants";

export default function ArticleAuthor({}) {
  return (
    <>
      <Head
        title={"Author: Amber Martinez | RealEstateAgents.com"}
        description={
          "Read the professional background of Amber Martinez, RealEstateAgents.com's Director of Strategic Operations."
        }
      />
      <div className={styles["ArticleAuthorAmber"]}>
        <div className={styles["ArticleAuthorAmber__feature-header"]}>
          <div className={styles["ArticleAuthorAmber__container"]}>
            <Breadcrumb
              passedCrumbs={["Articles", "Author", "Amber Martinez"]}
              passedPathname={[null, null, "/articles/author/amber-martinez"]}
              breadcrumbReady={true}
            />
            <div
              className={
                styles["ArticleAuthorAmber__feature-header__content-container"]
              }
            >
              <div className={styles["ArticleAuthorAmber__image-wrapper"]}>
                <Image
                  loading="lazy"
                  src="/static/images/articles/amber-martinez--sm.1x.jpg"
                  alt="Picture of the author"
                  width={132}
                  height={132}
                />
              </div>
              <div
                className={
                  styles["ArticleAuthorAmber__feature-header__content"]
                }
              >
                <h1 className={styles["ArticleAuthorAmber__heading"]}>
                  Amber Martinez
                </h1>
                <h6>Director of Strategic Operations</h6>
                <a
                  target="__blank"
                  href="https://www.linkedin.com/in/amber-martinez-7096651a/"
                >
                  <Image
                    loading="lazy"
                    src="/static/images/articles/linkedin--sm.1x.jpg"
                    alt="linkedin link for amber martinez"
                    width={24}
                    height={24}
                    className={styles["ArticleCard__image"]}
                  />
                </a>
              </div>
            </div>
          </div>
        </div>
        <div className={styles["ArticleAuthorAmber__container"]}>
          <div className={styles["ArticleAuthorAmber__content"]}>
            <h2 className={styles["ArticleAuthorAmber__sub-heading"]}>
              About Amber
            </h2>
            <h5 className={styles["ArticleAuthorAmber__sub-sub-heading"]}>
              Professional Information
            </h5>
            <p>
              Amber Martinez currently serves as Director of Strategic
              Operations with RealEstateAgents.com. As Director of Strategic
              Operations, Amber oversees the firm’s top performing agent
              accounts through its PRIME offering, as well as its agent
              recruitment strategies.
            </p>
            <p>
              Originally starting her career in real estate in 2012 as a
              Transaction Coordinator, Amber joined the RealEstateAgents.com
              team in 2016, managing Operations and Strategic Partnerships. Her
              many years in the industry have given her a rich history of
              experience with a deep understanding of the market and best
              practices.
            </p>
            <h5 className={styles["ArticleAuthorAmber__sub-sub-heading"]}>
              Hobbies
            </h5>
            <p>
              When not working, Amber stays active networking with the
              industry’s top agents and influencers over social media. She loves
              spending time with her family, listening to reggaeton, and is a
              Disney fanatic!
            </p>
            <hr />
          </div>
          <div className={styles["ArticleAuthorAmber__content"]}>
            <h2 className={styles["ArticleAuthorAmber__sub-heading"]}>Links</h2>
            <div className={styles["ArticleAuthorAmber__links"]}>
              <ul>
                {blogPosts.map((post) => (
                  <li>
                    <a href={post.slug}>{post.title}</a>
                  </li>
                ))}
              </ul>
            </div>
            <h2 className={styles["ArticleAuthorAmber__sub-heading"]}>
              Articles
            </h2>
            <div className={styles["ArticleAuthorAmber__links"]}>
              {articles.map((article) => (
                <ArticleCard
                  title={article.title}
                  author={"Amber Martinez"}
                  showAuthorContent={false}
                  slug={article.slug}
                />
              ))}
            </div>
          </div>
        </div>
      </div>
      <Script strategy="beforeInteractive" type="application/ld+json">
        {{
          "@context": "http://schema.org",
          "@type": "Person",
          name: "Amber Martinez",
          alumniOf: "American River College",
          jobTitle: "Director of Strategic Operations",
          knowsAbout: ["Operations", "Real Estate", "recruitment"],
          description:
            "Amber Martinez's many years in the industry have given her a rich history of experience with a deep understanding of the market and best practices.",
          url:
            "https://www.realestateagents.com/articles/author/amber-martinez",
          sameAs: "https://www.linkedin.com/in/amber-martinez-7096651a/",
        }}
      </Script>
    </>
  );
}
